function OutboundIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666666 4V10L6 13V7M0.666666 4L6 1L11.3333 4M0.666666 4L6 7M11.3333 4V7M11.3333 4L6 7M8 11H12.6667M12.6667 11L10.6667 9M12.6667 11L10.6667 13"
        stroke={!isActive ? '#828282' : '#FFFFFF'}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default OutboundIcon
